import { formatAmount } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetCommunityApprovalInfo } from "@/services";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useApprovalSettingsDtlCard = () => {
  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const bomPosition = communityDetail?.bomPosition;

  const [roleApprovalSettingsCard] = useState([
    {
      label: "Approve Budget",
      value: bomPosition?.approveBudgets ? "Yes" : "No",
      apiKey: "approveBudgets",
    },
    {
      label: "Approve Contract",
      value: bomPosition?.approveContract ? "Yes" : "No",
      apiKey: "approveContract",
    },
    {
      label: "Approve Contact Limit",
      value: formatAmount(bomPosition?.approveContractAmtLimit || "0"),
      apiKey: "approveContractAmtLimit",
    },
    {
      label: "Approve AP Invoice",
      value: bomPosition?.approveApInv ? "Yes" : "No",
      apiKey: "approveApInv",
    },
    {
      label: "Approve Limit",
      value: formatAmount(bomPosition?.approveApInvAmtLimit || "0"),
      apiKey: "approveApInvAmtLimit",
    },
    {
      label: "Yearly Approve Limit",
      value: formatAmount(bomPosition?.approveApInvAmtYearlyLimit || "0"),
      apiKey: "approveApInvAmtYearlyLimit",
    },
    {
      label: "Approve Work Orders",
      value: bomPosition?.approveWorkOrders ? "Yes" : "No",
      apiKey: "approveWorkOrders",
    },
    {
      label: "Approve Work Order Amt Limit",
      value: formatAmount(bomPosition?.approveWoAmtLimit || "0"),
      apiKey: "approveWoAmtLimit",
    },
    { label: "Pending Approve Limit", value: formatAmount("0") },
  ]);

  const [communityApprovalSettingsCard, setCommunityApprovalSettingsCard] =
    useState([
      {
        label: "Auto Approval Blanket Limit",
        value: "$0",
        apiKey: "autoApprovalBlanketLimit",
      },
      {
        label: "Aggregated Single Approval Amount Limit",
        value: "$0",
        apiKey: "singleLevelTotalLimit",
      },
      {
        label: "Board-Level Approval Limit",
        value: "$0",
        apiKey: "boardTotalLimit",
      },
    ]);

  const { data: communityApprovalInfo, isLoading: isCommunityLimitLoading } =
    useGetCommunityApprovalInfo({
      community_id: communityDetail?.communityId,
      queryParams: {
        enabled: !!communityDetail?.communityId,
      },
    });

  useEffect(() => {
    if (communityApprovalInfo?.data) {
      let card = [...communityApprovalSettingsCard];
      card = card?.map((data: any) => ({
        ...data,
        value: formatAmount(communityApprovalInfo?.data?.[data?.apiKey] || "0"),
      }));
      setCommunityApprovalSettingsCard([...card]);
    }
  }, [communityApprovalInfo]);

  return {
    roleApprovalSettingsCard,
    communityApprovalSettingsCard,
    isCommunityLimitLoading,
    communityDetail,
  };
};

export default useApprovalSettingsDtlCard;
